/** @format */

export default {
  /**
   * 导入配置，目前只支持excel导入
   */

  excel: {
    urls: {
      //车位资源管理
      parkingSpace: `bangdao/saasapi/v1/space/excelImport`,
      //产权车
      propertyCar: `bangdao/saasapi/v1/monthCard/property`,
      //长租车
      longRentalCar: `bangdao/saasapi/v1/monthCard/month`,
      //特殊车辆名单
      specialCarList: `bangdao/saasapi/v1/specialCar/excelImport`,
      //车场
      baseDevicePark: `/bangdao/saasapi/v1/baseDevice/importFile`,
      // 储值卡
      storedCardCreate: `/bangdao/saasapi/v1/storedCard/excelImport`
    }
  }
};
